module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/Fyoutube.a3a9ac2f.svg";